import { articleUrls } from "@clockwise/client-commons/src/constants/help-center";
import { Link } from "@clockwise/design-system";
import { appPaths } from "@clockwise/web-commons/src/constants/route.constants";
import { AIModal } from "@clockwise/web-commons/src/ui/ai-modal/AIModal";
import { getUrlForFeature } from "@clockwise/web-commons/src/util/routes.util";
import { useRouter } from "found";
import React, { useEffect } from "react";
import { TrackingEvents, track } from "../../util/analytics.util";

const AI_MARKETING_PAGE = "https://www.getclockwise.com/ai";

const NoAccessModalFooter = () => {
  return (
    <>
      <div className="cw-caption cw-text-center cw-text-onEmphasis">
        If you were recently granted access, refresh or try again later.
      </div>
      <div className="cw-caption cw-text-center cw-text-onEmphasis">
        Head back to our{" "}
        <Link onEmphasis href={getUrlForFeature("landing")}>
          home page
        </Link>
        , or{" "}
        <Link onEmphasis href={articleUrls.feedback}>
          contact us
        </Link>{" "}
        if you can't find what you're looking for.
      </div>
    </>
  );
};

export const AIModalPaywall = () => {
  const { router } = useRouter();

  useEffect(() => {
    track(TrackingEvents.AI_WAITLIST.MODAL_SHOWN);
  }, []);

  const goToJoin = () => {
    track(TrackingEvents.AI_WAITLIST.JOIN_BUTTON_CLICKED);
    window.open(AI_MARKETING_PAGE, "_blank");
  };

  const gotToHome = () => {
    track(TrackingEvents.AI_WAITLIST.DISMISS_BUTTON_CLICKED);
    router.push(appPaths.landing);
  };

  return (
    <AIModal
      primaryAction={goToJoin}
      secondaryAction={gotToHome}
      primaryActionText="Request access"
      secondaryActionText="Not now"
      title="Coming soon: Your new calendar assistant"
      description="AI Scheduler is replacing the legacy Clockwise Scheduler, which has been retired. Join the waitlist for the AI Scheduler Beta and we'll grant you access within a few business days."
      footer={<NoAccessModalFooter />}
    />
  );
};
